module.exports = __webpack_public_path__ + "92acda884054ad57fac1781164249bae.pdf";